import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  CheckBoxSelector,
  InputProps,
} from 'src/app/domain/shared/component/checkbox-selector/checkbox-selector.component';

@Component({
  selector: 'app-card-dropdown-checkbox',
  templateUrl: './card-dropdown-checkbox.component.html',
  styleUrls: ['./card-dropdown-checkbox.component.scss'],
})
export class CardDropdownCheckboxComponent implements OnChanges, OnDestroy {
  private _destroyStream = new Subject<void>();
  @Input() title: string;
  @Input() label: string;
  @Input() items: CheckBoxSelector[];
  @Input() props = new InputProps();
  @Output() itemEmitter = new EventEmitter<CheckBoxSelector[]>();

  showCheckboxSelector = false;
  allValuesCheckedText: AllSelectorName;
  selectedItemsText: string;
  autocompleteControl: FormControl<string>;

  ngOnChanges(): void {
    this.initAutocomplete();
    this.calculateItemsChecked();
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  toggleModal(): void {
    this.showCheckboxSelector = !this.showCheckboxSelector;
    if (!this.showCheckboxSelector) {
      this.itemEmitter.emit(this.items);
    }
  }

  changeSelection(item: CheckBoxSelector) {
    if (item.disabled) {
      return;
    }
    item.chosen = !item.chosen;
    this.calculateItemsChecked();
  }

  changeAllSelected(allValuesCheckedText: AllSelectorName): void {
    this.items
      .filter((item) => !item.isHidden)
      .forEach((el) => el.chosen = allValuesCheckedText === 'Select all');
    this.calculateItemsChecked();
  }

  calculateItemsChecked(): void {
    const numberOfSelectedItems = this.items?.filter((item) => item.chosen).length;
    this.selectedItemsText = numberOfSelectedItems === this.items?.length ? 'All' : numberOfSelectedItems.toString();
    this.allValuesCheckedText = numberOfSelectedItems === this.items?.length ? 'Unselect all' : 'Select all';
  }

  private initAutocomplete(): void {
    if (!this.props.isAutocompleteEnabled) {
      return;
    }
    this.autocompleteControl = new FormControl();
    this.autocompleteControl.valueChanges
      .pipe(takeUntil(this._destroyStream))
      .subscribe((value) => {
        this.items.forEach((item) => {
          item.isHidden = !item.item.toLowerCase().includes(value.toLowerCase());
        });
      });
  }
}


type AllSelectorName = 'Unselect all' | 'Select all';
